<template>
  <span class="echarts-line-three"><div :id="eid"></div></span>
</template>

<script>
import * as echarts from 'echarts';
export default {
  props: {
    eid: {
      type: String
    },
    data: {
      type:Object,
      default(){
        return {
          xLabel: ['03:00', '06:00', '09:00', '12:00', '15:00', '18:00', '19:00', '20:00', '21:00', '22:00', '23:00', '24:00'],
          xValue: [
            [120, 132, 101, 134, 90, 230, 210, 182, 191, 234, 290, 330],
            [220, 182, 191, 234, 290, 330, 310, 201, 154, 190, 330, 410],
            [150, 232, 201, 154, 190, 330, 410,150, 232, 201, 154, 190]
          ]
        }
      }
    }
  },
  data() {
    return {};
  },
  methods: {
    init() {
      let fontColor = '#08265F';
      let op = {
        grid: {
          left: '0%',
          right: '2%',
          top: '20%',
          bottom: '0%',
          containLabel: true
        },
        tooltip: {
          trigger: 'axis',
          backgroundColor:"#19cae4",
          padding:5,
          borderColor:'#22ade8',
          extraCssText:'width:auto;height:auto;color:#fff',
          textStyle:{
            color:'#fff'
          },
          axisPointer: {
            lineStyle: {
              color: {
                type: 'linear',
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  {
                    offset: 0,
                    color: 'rgba(255,255,255,0)' // 0% 处的颜色
                  },
                  {
                    offset: 0.5,
                    color: 'rgba(255,255,255,1)' // 100% 处的颜色
                  },
                  {
                    offset: 1,
                    color: 'rgba(255,255,255,0)' // 100% 处的颜色
                  }
                ],
                global: false // 缺省为 false
              }
            }
          }
        },
        legend: {
          show: true,
          x: 'right',
          y: 'top',
          icon: 'stack',
          itemWidth: 10,
          itemHeight: 10,
          textStyle: {
            color: '#3F485B'
          },
          data: ['1#充电桩', '2#充电桩', '3#充电桩']
        },
        xAxis: [
          {
            type: 'category',
            boundaryGap: false,
            axisLabel: {
              color: fontColor
            },
            axisLine: {
              show: false,
              lineStyle: {
                color: '#397cbc'
              }
            },
            axisTick: {
              show: false
            },
            splitLine: {
              show: false,
              lineStyle: {
                color: '#195384'
              }
            },
            data: this.data.xLabel
          }
        ],
        yAxis: [
          {
            type: 'value',
            name: '电量',
            min: 0,
            max: 1000,
            axisLabel: {
              formatter: '{value}',
              textStyle: {
                color: '#08265F'
              }
            },
            axisLine: {
              lineStyle: {
                color: '#3F485B'
              }
            },
            axisTick: {
              show: false
            },
            splitLine: {
              show: false,
              lineStyle: {
                color: '#11366e'
              }
            }
          }
        ],
        series: [
          {
            name: '1#充电桩',
            type: 'line',
            stack: '总量',
            symbol: 'circle',
            symbolSize: 4,
            itemStyle: {
              normal: {
                color: '#EFA544',
                lineStyle: {
                  color: '#EFA544',
                  width: 1
                },
                areaStyle: {
                  //color: '#94C9EC'
                  color: new echarts.graphic.LinearGradient(0, 1, 0, 0, [
                    {
                      offset: 0,
                      color: 'rgba(255,255,255,0.3)'
                    },
                    {
                      offset: 1,
                      color: 'rgba(239,165,68,0.9)'
                    }
                  ])
                }
              }
            },
            markPoint: {
              itemStyle: {
                normal: {
                  color: 'red'
                }
              }
            },
            data: this.data.xValue[0]
          },
          {
            name: '2#充电桩',
            type: 'line',
            stack: '总量',
            symbol: 'circle',
            symbolSize: 4,

            itemStyle: {
              normal: {
                color: '#19CAE4',
                lineStyle: {
                  color: '#19CAE4',
                  width: 1
                },
                areaStyle: {
                  //color: '#94C9EC'
                  color: new echarts.graphic.LinearGradient(0, 1, 0, 0, [
                    {
                      offset: 0,
                      color: 'rgba(255,255,255,0.3)'
                    },
                    {
                      offset: 1,
                      color: 'rgba(25,202,228,0.9)'
                    }
                  ])
                }
              }
            },
            data: this.data.xValue[1]
          },
          {
            name: '3#充电桩',
            type: 'line',
            stack: '总量',
            symbol: 'circle',
            symbolSize: 4,
            itemStyle: {
              normal: {
                color: '#0084EB',
                lineStyle: {
                  color: '#0084EB',
                  width: 1
                },
                areaStyle: {
                  //color: '#94C9EC'
                  color: new echarts.graphic.LinearGradient(0, 1, 0, 0, [
                    {
                      offset: 0,
                      color: 'rgba(255,255,255,0.3)'
                    },
                    {
                      offset: 1,
                      color: 'rgba(0,132,235,0.9)'
                    }
                  ])
                }
              }
            },
            data: this.data.xValue[2]
          }
        ]
      };
      this.options = op;
      return op;
    },
    reset() {
      this.$nextTick(function() {
        var myChart = echarts.init(document.getElementById(this.eid));
        let tmp = this.init();
        myChart.setOption(tmp);
      });
    }
  },
  mounted() {
    this.reset();
  }
};
</script>

<style lang="scss">
.echarts-line-three {
  position: relative;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: inline-block;
  div {
    width: 100%;
    height: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/svolt/project/components/nanwang/echarts-line-three.vue